import React from 'react';
import SectionsList from '../../../features/sections/SectionsList';

const DesktopSections = () => {
    return <SectionsList sectionLocation='mainPage' />;
};

export default DesktopSections;